import instance from "../../Redux/api/instance";

const useApi = () => {
  const controller = new AbortController();

  const getApiCAll = (url, headers = {}, params = {}) => {
    return instance.get(url, {
      signal: controller.signal,
      headers,
      params,
    });
  };

  const postApiCAll = (url, data, headers) => {
    return instance.post(url, data, {
      signal: controller.signal,
      headers,
    });
  };

  const putApiCAll = (url, data, headers = {}) => {
    return instance.put(url, data, {
      signal: controller.signal,
      headers,
    });
  };

  const cancellCall = () => {
    controller.abort();
  };

  return { getApiCAll, postApiCAll, putApiCAll, cancellCall };
};

export default useApi;
